import React from "react";
import emoji from "react-easy-emoji";
import "./Footer.scss";

import { footer } from "../../portfolio";

export default function Footer() {
  if (footer && typeof footer === "object" && footer.display === false) return null;

  const text = footer && typeof footer === "object" ? footer.text : "";
  const links = footer && typeof footer === "object" && Array.isArray(footer.links) ? footer.links : [];

  return (
    <div className="footer-div" id="footer">
      <p className="footer-text">{emoji(text || "")}</p>

      {links.length > 0 && (
        <div className="footer-links">
          {links
            .filter(l => l && l.label && l.url)
            .map((l, idx) => (
              <a
                key={`${l.url}-${idx}`}
                className="footer-link"
                href={l.url}
                target="_blank"
                rel="noreferrer"
              >
                {l.label}
              </a>
            ))}
        </div>
      )}
    </div>
  );
}
